import interactions from "./interactions";
import options from "./options";
import preview from "./preview";

export default {
    ...interactions,
    options,
    preview
};
